import { useSelector } from "react-redux";
import { getAccessToken } from "./authSlice";

const useAccessToken = () => {
  return useSelector(getAccessToken);
};

export { useAccessToken };
